module.exports = __webpack_public_path__ + "img/image_bg.c7812e45.jpg";